export default {
  'menu.welcome': 'ยินดีต้อนรับ',
  'menu.entity': 'Entity',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'หน้าแรก',
  'menu.admin': 'ผู้ดูแลระบบ',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'เข้าสู่ระบบ',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Apps',
  'menu.dashboard.monitor': 'Monitor',
  'menu.flow': 'Flow',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.user-management': 'Users',
  'menu.tag-management': 'Tags',
  'menu.canned-response': 'Canned',
  'menu.chatrooms': 'Chatrooms',
  'menu.email': 'Email',
  'menu.core': 'คุณสมบัติหลัก',
  'menu.files': 'ไฟล์',
  'menu.favouritesHub': 'เรื่อง',
  'menu.grading': 'Grading',
  'menu.setting': 'การตั้งค่า',
  'menu.context': 'Context',
  'menu.management': 'จัดการ',
  'menu.conversation': 'Convos',
  'menu.broadcast': 'Broadcast',
  'menu.dictionary': 'Dictionary',
  'menu.question': 'Question',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': 'New Flow',
  'menu.form.update-flow': 'Modify Flow',
  'menu.list.flow-list': 'Flow List',
  'menu.library': 'คลังพรอมต์',
  'menu.chat': 'แชท',
  'menu.search': 'ค้นหา',
  'menu.specialised': 'เฉพาะทาง',
  'menu.app': 'แอป',
  'menu.playbook': 'Workstudio',
  'menu.template': 'เอาต์พุตที่กำหนดเอง',
  'menu.quote': 'ใบเสนอราคา',
  'menu.review': 'ตรวจสอบ',
  'menu.sideBySide': 'เปรียบเทียบแบบเคียงข้าง',
  'menu.diagnostics': 'การวินิจฉัย',
  'menu.translation': 'การแปล',
  'menu.comparison': 'เปรียบเทียบ',
  'menu.scribe': 'บันทึกเสียง',
  'menu.organisation': 'องค์กร',
  'menu.divider': 'เส้นแบ่ง',
  'menu.filesNew': 'ไฟล์ (ใหม่)',
  'menu.filesRefactored': 'ไฟล์ (ปรับปรุงใหม่)',
  'menu.superAdminOrganisation': 'องค์กรผู้ดูแลระบบสูงสุด',
  'menu.section.vault': 'คลังเก็บ',
  'menu.section.chatAndCompose': 'แชทและเขียนเอกสาร',
  'menu.section.specialised': 'เฉพาะทาง',
  'menu.section.system': 'ระบบ',
};
